// import Vue from "vue";
// var plugin = new Vue();
export const app = {
  grid: {
    noData: "Data tidak ditemukan",
    loading: "Silahkan tunggu sejenak ...",
    create: "Baru",
    search: "Cari ...",
  },
  discussion: {
    open: "Menunggu",
    closed: "Selesai",
    unreviewed: "Belum Dicek",
  },
  confirmation: {
    title: "Konfirmasi",
    yes: "Ya",
    no: "Batal",
  },
  notification: {
    position: "top-right",
    timeout: 2000,
  },
  yearPeriode: new Date().getUTCFullYear(),
  approvalType:"RPT",
  role: {
    admin:"ADMIN",
    user:"USER",
  },
  // urlOrigin:  (new URL(plugin.$axios.defaults.baseURL)).origin,
};

export default {
  namespaced: true,
  state: {
    ...app,
  },
  mutations: {
    setApprovalType(state, approvalType) {
      state.approvalType = approvalType;
    },
  },
  actions: {
    updateApprovalType(context, approvalType){
      context.commit("setApprovalType", approvalType);
    },
    toBase64(file) {
          let res;
          const reader = new FileReader();
          reader.readAsDataURL(file);
          res = reader.result;
          return res
    },
  },
  getters: {
    getApprovalType(state) {
        return state.approvalType;
    },
  },
};
